import React from 'react'
import { useSelector } from 'react-redux'
import { getLoggedInUser } from '../../application/store/selectors/user'

function TopBar() {

    const user = useSelector(getLoggedInUser);

    return (
        <div className=" px-4 py-8 border bg-themeGreen text-lg text-white flex justify-between">
            <span></span> 
            <h2>Logged in as {user.firstName} {user.lastName}</h2>
        </div>
    )
}

export default TopBar